import React from "react";

import ZbiorowyKomornikTablePrzelewy from "./ZbiorowyKomornikTablePrzelewy";
import ZbiorowyKomornikTableCzynsze from "./ZbiorowyKomornikTableCzynsze";

const ZbiorowyKomornikTable = props => {

    const { showKomornik, czynsze, przelewy_g, przelewyRok, czynszeRok, sumaCzynszeTenRok, sumaPrzelewyTenRok, stawkiInd, saldoStare } = props;

    return (
        <section
            style={{
                marginTop: "40px"
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-around"
                }}
            >
                <ZbiorowyKomornikTableCzynsze
                    showKomornik={showKomornik}
                    czynsze={czynsze}
                    przelewy_g={przelewy_g}
                    przelewyRok={przelewyRok}
                    czynszeRok={czynszeRok}
                    sumaCzynszeTenRok={sumaCzynszeTenRok}
                    stawkiInd={stawkiInd}
                    saldoStare={saldoStare}
                />
                <ZbiorowyKomornikTablePrzelewy
                    przelewy_g={przelewy_g}
                    sumaPrzelewyTenRok={sumaPrzelewyTenRok}
                />
            </div>

        </section>
    )
}

export default ZbiorowyKomornikTable;